import React, { Component } from "react";
import StripeCheckout from "react-stripe-checkout";
import Button from "../../Button/Button";
import Logo from '../../../assets/logos/logo.png';
import "./Payment.css";

class Payment extends Component {

    constructor(props) {
        super(props);
        var global = require("../../../global.js");
        this.state = {
            stripe_key: global.stripe_key,
        }
    }
	componentWillMount() {
		this.total = this.props.getSignUpProductTotalBuyer();
		this.stripeTotal = Math.round(this.total * 100);
	}
	render() {
			
		return (
			<div>
				<div className="payment-content">
					<p className="payment-info-disc">
						Please Note: the potential buyer list is machine-generated and provided for informational purposes only. No content on the list is intended to constitute professional advice. FMeasure Inc. is not responsible or liable for any consequences relating directly or indirectly to any action you take or fail to take based on the information on the list.
						The data underlying the Content has been obtained from sources that are believed to be reliable but neither FMeasure Inc. nor any third party providing such data guarantee the accuracy, completeness or timeliness of the underlying data, any Content or any projections based thereon. You must verify all information.
						For more details, see our <a href= "https://www.fmeasure.com/wp-content/uploads/2018/11/term_of_use.pdf">Terms of Use</a> and <a href= "https://www.fmeasure.com/wp-content/uploads/2018/11/privacy_policy.pdf">Privacy Policy</a>.
						<br></br>
						<br></br>
						Please review the following information. By clicking the button, you agree to pay the fee listed below.
					</p>
					<br />
					<p className="payment-info-user">{`BUYER LIST GENERATION SERVICE (ONE TIME USE).`}</p>
					<p className="payment-info-user">
						{this.props.signUpParamsBuyer.firstName &&
							this.props.signUpParamsBuyer.firstName}{" "}
						{this.props.signUpParamsBuyer.lastName &&
							this.props.signUpParamsBuyer.lastName}{" "}
						{this.props.signUpParamsBuyer.user &&
							`(${this.props.signUpParamsBuyer.user})`}
					</p>

					<p className="payment-info-user">{`$${this.total}`}</p>
					<br />
					<StripeCheckout
						name="FMeasure Inc."
						image={Logo}
						currency="USD"
						amount={this.stripeTotal}
						allowRememberMe={false}
						token={this.props.onTokenBuyer}
						stripeKey={this.state.stripe_key}
					>
					<Button label="Pay with card" />
					</StripeCheckout>
				</div>
			</div>
		);
	}
}

export default Payment;


// WEBPACK FOOTER //
// ./src/components/BuyerList/Payment/Payment.js